import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items, dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-8 lg:py-10 ${
        dark ? "border-white/10 bg-ink" : "border-mist bg-white"
      }`}
    >
      <Marquee speed={32} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`whitespace-nowrap px-10 font-serif text-4xl font-light italic tracking-tight sm:text-5xl lg:text-6xl ${
                dark ? "text-white/25" : "marquee-outline"
              }`}
            >
              {item}
            </span>
            <span className="inline-block h-2 w-2 rotate-45 bg-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
